// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"userAvatar_imageWrapper__WorbN","closeIcon":"userAvatar_closeIcon__1jeHr"};